import React from 'react'
import styled from '@emotion/styled'
import { colors, radius, spacing } from '@mobi/component-library/Theme/Common'
import { Icon } from '@mobi/component-library/Common/V2'

export const ProfileImage: React.FC<{
  url: string
  shouldDisplayCheck: boolean
}> = ({ url, shouldDisplayCheck }) => {
  return (
    <WrapperStyled>
      <img src={url} alt='Image of Expert Hub Tipster from Contentful' />

      {shouldDisplayCheck ? (
        <Icon name='SolidCheckVerified02' color={colors.studio[600]} size={spacing.md} />
      ) : null}
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  position: 'relative',

  '> img': {
    borderRadius: radius.full,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  '> span': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: spacing.md,
    height: spacing.md,
    position: 'absolute',
    right: 0,
    bottom: 0,
    transform: 'translate(20%, 20%)',
    filter:
      'drop-shadow(1px 0 0 white) drop-shadow(-1px 0 0 white) drop-shadow(0 1px 0 white) drop-shadow(0 -1px 0 white)',
  },
})
